(ns client-portal.client.oasys.sessions.drill
  (:require [clojure.string :as s]
            [client-portal.client.components.drill :as drill]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.sessions.data :as vi.sessions.d]
            [shared.core.router :as router]
            [shared.core.util :as util]))

(defn- filter-value
  "A chart value as the option the Sessions filter `by` selects for it, or nil when it
   names none."
  [by v metric]
  (let [v-str (str v)]
    (case by
      ("topics" "channel") (drill/option v-str v-str)
      "intents" (drill/option (tag/intent-name->display-name v-str) v-str)
      "resolution" (let [status (s/upper-case v-str)]
                     (drill/option (util/->capitalize-words status) status))
      "escalation" (case (s/lower-case v-str)
                     ("true" "escalated") (drill/option "Escalated" "escalated")
                     ("false" "contained") (drill/option "Contained" "contained")
                     nil)
      "metrics" (when metric
                  (drill/option metric v-str))
      "day-of-week" (drill/day-of-week-option v)
      "time-of-day" (drill/time-of-day-option v)
      "duration" (drill/duration-option v)
      nil)))

(defn sessions-query-params [context drill click report-filters]
  (let [constraints (drill/constraints drill click context report-filters)
        topic-children (->> constraints
                            (filter #(= "topic-resolution" (:filter %)))
                            (mapv (fn [{:keys [values condition]}]
                                    {:by "resolution-status"
                                     :condition (or condition "include")
                                     :join "or"
                                     :value (mapv #(s/upper-case (str %)) values)})))
        session-filters (->> constraints
                             (keep (fn [{by :filter :keys [values condition join metric]}]
                                     ;; The Sessions filter keys a metric by its code's kebab-case form.
                                     (let [metric (some-> metric (util/->kebab-case-string))]
                                       (when-let [value (->> values
                                                             (filter drill/value-set?)
                                                             (keep #(filter-value by % metric))
                                                             (vec)
                                                             (not-empty))]
                                         (cond-> {:by by
                                                  :condition (or condition "include")
                                                  :join (or join "or")
                                                  :value value}
                                                 metric (assoc :metric metric)
                                                 (= by "topics") (assoc :children topic-children))))))
                             (vec))]
    (util/remove-nil-from-map
      (assoc (drill/layout-query-params context constraints report-filters)
        :fd (vi.sessions.d/filters->query-param session-filters)))))

(defn open-sessions [e context drill click report-filters]
  (router/open-route-based-on-event e [:oasys/sessions nil (sessions-query-params context drill click report-filters)]))
